import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";

const TERMS_CONTENT = [
  {
    section: "1. Taxes",
    text: "Prices mentioned are exclusive of GST unless explicitly stated otherwise. GST shall be charged as applicable under the Goods and Services Tax laws in India.",
  },
  {
    section: "2. Activation of Services",
    text: "The Skill Genie subscriptions, Bootcamp enrollments, platform access, learning credits, AI feature access, premium learning modules, assessments, certifications, and other purchased services shall be activated only after successful payment confirmation and receipt of cleared funds by EVOLVE X INNOVATIONS.",
  },
  {
    section: "3. SaaS Platform",
    text: "The Skill Genie is a cloud-based Software-as-a-Service (SaaS) learning, skill development, career readiness, and employability platform. Access is provided on a subscription, institutional, enterprise, Bootcamp, usage-based, or other commercially agreed basis and remains valid only for the purchased or contractually agreed duration.",
  },
  {
    section: "4. Subscription Scope",
    text: "Access to The Skill Genie features, including but not limited to AI-powered learning, Bootcamps, LaunchPad learning tracks, TechExplorer, practice assessments, coding challenges, mock interviews, resume evaluation, AI career guidance, skill analytics, certifications, learning reports, and other platform capabilities, shall be governed by the limits, duration, and entitlements of the purchased subscription plan, institutional agreement, enterprise agreement, or other applicable commercial arrangement.",
  },
  {
    section: "5. Plan Limits and Usage",
    text: "Access to learning modules, Bootcamp enrollments, AI feature usage, assessments, coding challenges, mock interviews, resume evaluations, certifications, storage, user seats, institutional licenses, learning credits, and other platform entitlements may vary depending on the subscribed plan or commercial agreement. Usage beyond the included limits may require the purchase of additional subscriptions, credits, add-ons, or plan upgrades.",
  },
  {
    section: "6. Non-Refundable Payments",
    text: "All subscription fees, Bootcamp fees, course fees, institutional subscription fees, enterprise plan fees, learning credits, AI feature credits, implementation charges, onboarding fees, setup fees, custom development charges, certification fees, and any other payments made to EVOLVE X INNOVATIONS are non-refundable and non-transferable, except where required under applicable law.",
  },
  {
    section: "7. No Cancellation After Payment",
    text: "No cancellation is permitted after successful payment confirmation and activation of the applicable subscription, Bootcamp enrollment, course access, add-on, institutional plan, enterprise plan, or any other purchased service. Once activated, the purchase cannot be cancelled, reversed, or converted into cash.",
  },
  {
    section: "8. No Transfer or Exchange",
    text: "Purchased subscriptions, Bootcamp enrollments, platform licenses, learning credits, AI feature access, assessments, mock interview credits, certifications, institutional licenses, add-ons, or other entitlements cannot be exchanged for cash, transferred to another individual, institution, or organization, or adjusted against future purchases unless explicitly approved in writing by EVOLVE X INNOVATIONS.",
  },
  {
    section: "9. Expiry of Unused Entitlements",
    text: "Any unused learning credits, AI feature credits, assessments, mock interview attempts, certifications, platform licenses, add-ons, Bootcamp access, course access, or remaining subscription validity shall expire in accordance with the applicable purchased plan, validity period, or commercial agreement and shall not be eligible for refund, carry-forward, or extension unless explicitly stated otherwise in writing by EVOLVE X INNOVATIONS.",
  },
  {
    section: "10. Customer Billing Information",
    text: "The customer, institution, organization, or individual subscriber is responsible for providing accurate and complete billing information, including legal entity name, student or organization details where applicable, GSTIN (if applicable), billing address, authorized contact details, and any other information required before invoice generation.",
  },
  {
    section: "11. Refund & Cancellation Policy",
    text: "All payments made towards The Skill Genie subscriptions, Bootcamp enrollments, course fees, institutional plans, enterprise plans, implementation services, onboarding services, learning credits, AI feature credits, assessments, certifications, add-ons, or any other services are final. No Refunds, No Cancellations, and No Transfers are permitted after successful payment, except where required under applicable law.",
  },
  {
    section: "12. AI-Powered Features",
    text: "The Skill Genie may use artificial intelligence and automated systems to provide personalized learning recommendations, AI tutoring, career guidance, resume evaluation, mock interviews, coding assistance, skill assessments, learning analytics, progress tracking, certifications, content recommendations, reports, and other learning- and career-related functions. AI-generated outputs are intended to assist learning, skill development, and career preparation and should not be treated as the sole basis for academic, professional, employment, certification, or other high-impact decisions.",
  },
  {
    section: "13. User Responsibility for Learning and Career Decisions",
    text: "Users, institutions, organizations, and other customers remain solely responsible for reviewing learning materials, validating AI-generated recommendations, verifying assessment outcomes, evaluating certifications, and making their own academic, professional, career, or employment-related decisions. EVOLVE X INNOVATIONS does not guarantee successful course completion, certification, academic performance, job placement, employment opportunities, interview success, career advancement, or any specific learning outcome through the use of The Skill Genie.",
  },
  {
    section: "14. Accuracy of AI Outputs",
    text: "While reasonable efforts are made to improve the quality and reliability of AI-powered features, EVOLVE X INNOVATIONS does not warrant that AI-generated explanations, recommendations, learning paths, coding assistance, resume evaluations, mock interview feedback, assessments, scores, reports, certifications, summaries, or other outputs will always be complete, accurate, error-free, unbiased, or suitable for every educational, professional, or career-related context.",
  },
  {
    section: "15. User Data and Lawful Use",
    text: "The customer, institution, organization, or individual user is responsible for ensuring that student information, resumes, educational records, assessment data, coding submissions, GitHub information, certifications, learning progress, contact information, and any other personal data uploaded, collected, processed, or used through The Skill Genie are handled with appropriate authority, notice, consent, or other lawful basis as required under applicable law.",
  },
  {
    section: "16–20. Platform Policies",
    text: "The Skill Genie communicates through supported channels; delivery depends on third-party providers. Third-party integrations are not under our direct control. Users shall not misuse the platform for unlawful activities, academic misconduct, or security attacks. Users are responsible for their account security. We use commercially reasonable efforts to maintain availability but uninterrupted access is not guaranteed.",
  },
  {
    section: "21–24. Support, Changes & Suspension",
    text: "Technical support is provided during business hours per your plan. We reserve the right to update or discontinue features with material notice. Access may be suspended for fraud, payment default, or misuse. Statutory charges introduced after invoice date are payable by the customer.",
  },
  {
    section: "25. Limitation of Liability",
    text: "To the maximum extent permitted by applicable law, EVOLVE X INNOVATIONS shall not be liable for any indirect, incidental, special, consequential, or business losses arising from the use of The Skill Genie, including loss of data, learning progress, academic outcomes, employment opportunities, certifications, third-party service interruptions, or reliance on AI-generated outputs.",
  },
  {
    section: "26. No Employment or Academic Guarantee",
    text: "Use of The Skill Genie does not guarantee successful course completion, certifications, academic performance, skill proficiency, internships, employment, interview success, career advancement, or any specific educational or professional outcome.",
  },
  {
    section: "27. Electronic Invoice",
    text: "Any invoice issued electronically is a computer-generated document and does not require a physical signature, subject to applicable legal and tax requirements.",
  },
  {
    section: "28. Governing Law and Jurisdiction",
    text: "These Terms and any transaction relating to The Skill Genie shall be governed by the laws of India. All disputes arising from or relating to the subscription, services, or use of The Skill Genie shall be subject to the exclusive jurisdiction of the competent courts at Vijayawada, Andhra Pradesh, India.",
  },
  {
    section: "29. Acceptance of Terms",
    text: "By purchasing, subscribing to, accessing, or using The Skill Genie, the user, customer, institution, or organization acknowledges that they have read, understood, and agreed to these Terms & Conditions, together with any applicable order form, quotation, invoice, proposal, subscription plan, Privacy Policy, or other written agreement executed with EVOLVE X INNOVATIONS.",
  },
];

const PRIVACY_CONTENT = [
  {
    section: "1. Introduction",
    text: "Welcome to The Skill Genie ('The Skill Genie', 'we', 'our', or 'us'), an AI-powered learning and employability platform. This Privacy Policy explains how we collect, use, store, process, disclose, and protect your personal information when you access or use our website, applications, APIs, and related services. By creating an account or using our Platform, you acknowledge that you have read and agree to the practices described in this Privacy Policy. Effective Date: July 8, 2026.",
  },
  {
    section: "2. Definitions",
    text: "Platform means The Skill Genie website, web application, mobile application, APIs, and all related services. User means any individual, student, faculty member, recruiter, institution administrator, employer, or organization using the Platform. Institution means any college, university, training institute, educational organization, or academic partner registered with The Skill Genie. Personal Information means any information that identifies or can reasonably identify an individual. AI Services refers to AI-powered features including learning recommendations, resume evaluation, interview analysis, coding evaluation, career guidance, and personalized feedback.",
  },
  {
    section: "3. Information We Collect",
    text: "To deliver our services efficiently and securely, we collect information directly from you, automatically through your use of the Platform, and, where applicable, from authorized third-party sources. Categories include: personal identification information, educational and professional information, account credentials, learning progress, assessment results, resume and portfolio information, payment and subscription details, and usage analytics.",
  },
  {
    section: "4. Student Information",
    text: "When students register or use The Skill Genie, we may collect: full name, email address, mobile number, date of birth (optional), gender (optional), city, state, and country, educational qualification, college or university, branch or specialization, graduation year, skills and interests, and employment preferences. This information enables personalized learning recommendations, AI-powered evaluations and progress tracking.",
  },
  {
    section: "5. Institution Information",
    text: "Educational institutions using The Skill Genie may provide: institution name, logo, contact details, address, authorized administrators, student enrollment information, department details, and batch information. Institution administrators may access dashboards with aggregated student performance, learning analytics, and skill development metrics. Institutions are responsible for ensuring they have appropriate authority to share student information with The Skill Genie.",
  },
  {
    section: "6. AI-Generated Data",
    text: "The Skill Genie leverages Artificial Intelligence to deliver intelligent and personalized learning experiences. AI-generated data may include learning recommendations, resume evaluation, mock interview performance evaluation and feedback, explanations of topics, and generated interview questions. AI-generated outputs may contain errors, limitations, or inaccuracies. Users remain responsible for reviewing AI-generated content and making their own informed decisions.",
  },
  {
    section: "7. Cookies and Similar Technologies",
    text: "The Skill Genie uses cookies, local storage, session storage, and similar technologies to keep users securely logged in, remember preferences and settings, improve website performance, analyze platform usage, personalize learning experiences, and detect suspicious activities. Users may configure browser settings to refuse or delete cookies, though this may affect certain features of the Platform.",
  },
  {
    section: "8. Payment Information",
    text: "Payments are processed through secure and authorized third-party payment service providers. The Skill Genie does not store complete debit card numbers, credit card numbers, CVV, UPI PINs, net banking passwords, or other sensitive payment credentials. Payment providers are responsible for securely processing financial transactions in accordance with applicable security standards.",
  },
  {
    section: "9. Data Security",
    text: "We implement commercially reasonable administrative, technical, and organizational safeguards including: secure authentication mechanisms, role-based access controls, multi-layer application security, continuous system monitoring, regular security updates and patches, secure software development practices, and backup and disaster recovery procedures. While we strive to protect your information, no method of electronic storage or internet transmission can be guaranteed to be completely secure.",
  },
  {
    section: "10. Encryption",
    text: "Sensitive information transmitted between users and The Skill Genie is protected using industry-standard encryption technologies, safeguarding user authentication, personal information, assessment data, resume uploads, and payment-related communications.",
  },
  {
    section: "11. Third-Party Integrations",
    text: "To provide our services, The Skill Genie may integrate with trusted third-party providers including payment gateways, cloud hosting providers, authentication services, email and communication providers, analytics platforms, and Artificial Intelligence service providers. These third parties process information only to the extent necessary to provide their respective services.",
  },
  {
    section: "12–14. International Transfers, DPDP Act & GDPR",
    text: "Where international data transfers occur, we take reasonable measures to ensure personal information receives appropriate protection consistent with applicable data protection laws. We are committed to processing personal data in accordance with India's Digital Personal Data Protection Act, 2023, and strive to follow internationally recognized privacy principles including lawful processing, transparency, data minimization, purpose limitation, accuracy, storage limitation, and accountability.",
  },
  {
    section: "15. Changes to this Privacy Policy",
    text: "We may revise this Privacy Policy periodically to reflect changes in our services, technology, legal requirements, or business practices. Updated versions will be published on our Platform with a revised 'Last Updated' date. Continued use of the Platform after changes become effective constitutes acceptance of the updated Privacy Policy.",
  },
  {
    section: "16. Contact Information",
    text: "For any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact us: The Skill Genie, Email: connect@evolvexinnovations.com, Website: https://www.theskillgenie.com. We will make reasonable efforts to respond to your inquiries in a timely manner.",
  },
];

const LegalDocumentModal = ({ isOpen, onClose, documentType }) => {
  const scrollRef = useRef(null);
  const isTerms = documentType === "terms";
  const title = isTerms ? "Terms & Conditions" : "Privacy Policy";
  const content = isTerms ? TERMS_CONTENT : PRIVACY_CONTENT;
  const effectiveDate = "July 8, 2026";

  useEffect(() => {
    if (isOpen && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [isOpen, documentType]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handleKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = "";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 99999,
        background: "rgba(15,23,42,0.65)",
        backdropFilter: "blur(6px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
        boxSizing: "border-box",
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        style={{
          background: "#FFFFFF",
          borderRadius: "20px",
          width: "100%",
          maxWidth: "780px",
          maxHeight: "calc(100vh - 40px)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 32px 80px rgba(15,23,42,0.28)",
          border: "1.5px solid #E2E8F0",
        }}
      >
        {/* Sticky header */}
        <div
          style={{
            padding: "20px 28px",
            borderBottom: "1.5px solid #F1F5F9",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#FFFFFF",
            flexShrink: 0,
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
              <div
                style={{
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #6D4AFF, #9B72FF)",
                  flexShrink: 0,
                }}
              />
              <h2
                style={{
                  fontSize: "18px",
                  fontWeight: 800,
                  color: "#0F172A",
                  margin: 0,
                  letterSpacing: "-0.01em",
                  fontFamily: "'Inter','Segoe UI',sans-serif",
                }}
              >
                {title}
              </h2>
            </div>
            <p
              style={{
                fontSize: "12px",
                color: "#94A3B8",
                margin: 0,
                fontWeight: 500,
                fontFamily: "'Inter','Segoe UI',sans-serif",
              }}
            >
              The Skill Genie · Evolve X Innovations · Effective {effectiveDate}
            </p>
          </div>
          <button
            onClick={onClose}
            aria-label="Close modal"
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "10px",
              border: "1.5px solid #E2E8F0",
              background: "#F8FAFC",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#64748B",
              flexShrink: 0,
              transition: "background 120ms",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#F1F5F9"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#F8FAFC"; }}
          >
            <X style={{ width: "16px", height: "16px" }} />
          </button>
        </div>

        {/* Scrollable body */}
        <div
          ref={scrollRef}
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "28px",
            fontFamily: "'Inter','Segoe UI',sans-serif",
          }}
        >
          {content.map((item, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: "24px",
                paddingBottom: "24px",
                borderBottom: idx < content.length - 1 ? "1px solid #F1F5F9" : "none",
              }}
            >
              <h3
                style={{
                  fontSize: "13px",
                  fontWeight: 800,
                  color: "#6D4AFF",
                  margin: "0 0 8px",
                  textTransform: "uppercase",
                  letterSpacing: "0.04em",
                }}
              >
                {item.section}
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#374151",
                  margin: 0,
                  lineHeight: 1.75,
                  fontWeight: 400,
                }}
              >
                {item.text}
              </p>
            </div>
          ))}

          <div
            style={{
              background: "#F5F3FF",
              border: "1.5px solid #DDD6FE",
              borderRadius: "12px",
              padding: "16px 20px",
              marginTop: "8px",
            }}
          >
            <p
              style={{
                fontSize: "12px",
                color: "#4C1D95",
                margin: 0,
                lineHeight: 1.6,
                fontWeight: 500,
              }}
            >
              This document is effective as of {effectiveDate}. For questions contact{" "}
              <a
                href="mailto:connect@evolvexinnovations.com"
                style={{ color: "#6D4AFF", fontWeight: 700 }}
              >
                connect@evolvexinnovations.com
              </a>
            </p>
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "16px 28px",
            borderTop: "1.5px solid #F1F5F9",
            background: "#FAFAFA",
            flexShrink: 0,
          }}
        >
          <button
            onClick={onClose}
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: "12px",
              border: "1.5px solid #E2E8F0",
              background: "#FFFFFF",
              fontSize: "14px",
              fontWeight: 700,
              color: "#475569",
              cursor: "pointer",
              fontFamily: "'Inter','Segoe UI',sans-serif",
              transition: "background 120ms",
            }}
            onMouseEnter={(e) => { e.currentTarget.style.background = "#F8FAFC"; }}
            onMouseLeave={(e) => { e.currentTarget.style.background = "#FFFFFF"; }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalDocumentModal;
